import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { FORM_ERRORS } from '@ib-enums/form-control-errors.enum';
import * as ibantools from 'ibantools';

// todo like a localization keys

export const ValidationErrorsIbanErrors = {
  [ibantools.ValidationErrorsIBAN.NoIBANProvided]: 'No IBAN Provided',
  [ibantools.ValidationErrorsIBAN.NoIBANCountry]: 'No IBAN Country',
  [ibantools.ValidationErrorsIBAN.WrongBBANLength]: 'Wrong BBAN Length',
  [ibantools.ValidationErrorsIBAN.WrongBBANFormat]: 'Wrong BBAN Format',
  [ibantools.ValidationErrorsIBAN.ChecksumNotNumber]: 'Checksum Not Number',
  [ibantools.ValidationErrorsIBAN.WrongIBANChecksum]: 'Wrong IBAN Checksum',
  [ibantools.ValidationErrorsIBAN.WrongAccountBankBranchChecksum]:
    'Wrong Account Bank Branch Checksum',
  [ibantools.ValidationErrorsIBAN.QRIBANNotAllowed]: 'QRIBAN Not Allowed',
};

export function IbanValidator(): ValidatorFn {
  return (fc: FormControl): ValidationErrors | null => {
    const v = fc.value?.replace(/\s/g, '');
    if (v) {
      const data = ibantools.validateIBAN(v);
      if (!data.valid) {
        return {
          [FORM_ERRORS.IBAN_INVALID]: data.errorCodes.map(
            i => ValidationErrorsIbanErrors[i],
          ),
        };
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
}
